import { General } from './General'
import { Statistic } from './Statistic'
import { Statistics } from './Statistics'

export const Component = { General, Statistics, Statistic }
